/*
  MOMERY CUSTOM: Mitlaufende Kaufleiste für Handys.

  Die Leiste ist bewusst nur eine Fernbedienung: Sie spiegelt den echten Kaufbutton
  der Produktseite (#AddToCart oder den Printess-Button "Jetzt gestalten") und löst
  beim Tippen dessen Klick aus. Variantenwahl, Menge, die FLYERALARM-Zuordnung und
  der Printess-Editor bleiben dadurch unverändert im Original.

  Sichtbar wird sie nur, wenn der echte Kaufbutton gerade nicht im Bild ist und kein
  Cookie-Banner unten liegt. Geprüft wird bei Scrollen, Größenänderung, DOM-Änderungen
  und in den ersten Sekunden zusätzlich getaktet, weil der Printess-Button nachgeladen
  wird.

  Der Preis kommt aus dem Preisblock der Produktseite (snippets/product-price.liquid):
  <del> ist der Streichpreis, <ins> der aktuelle Preis. Beide werden als reiner Text
  in eigene Elemente der Leiste geschrieben; fremdes HTML wird nicht übernommen.
*/
(function () {
  var EXCLUDE = 'mobile-sticky-atc, product-add-to-cart-sticky';

  function clean(node) {
    return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  // Liest aktuellen Preis und Streichpreis aus einem .price-Block des Themes.
  // Grundpreis (.unit-price) und Badges (.badges) gehören nicht in die Leiste.
  function readPrice(source) {
    if (!source) return null;

    var now = clean(source.querySelector('ins .amount') || source.querySelector('ins'));
    var was = clean(source.querySelector('del .amount') || source.querySelector('del'));

    if (!now) {
      // Unbekannter Aufbau: den sichtbaren Text ohne Streichpreis, Grundpreis und Badges nehmen.
      var clone = source.cloneNode(true);
      var noise = clone.querySelectorAll('del, .unit-price, .badges');
      for (var i = 0; i < noise.length; i++) noise[i].remove();
      now = clean(clone);
    }

    if (!now) return null;
    if (was === now) was = '';
    return { now: now, was: was };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { readPrice: readPrice };
  if (typeof customElements === 'undefined' || customElements.get('mobile-sticky-atc')) return;

  function isVisible(element) {
    return !!element && element.offsetParent !== null && element.getClientRects().length > 0;
  }

  class MobileStickyAtc extends HTMLElement {
    connectedCallback() {
      // Hat ein Elternelement eine Transformation, klebt position:fixed nicht am
      // Fenster. Deshalb hängt sich die Leiste einmalig direkt unter <body>.
      if (!this.moved && this.parentElement !== document.body) {
        this.moved = true;
        document.body.appendChild(this);
        return;
      }
      if (this.ready) return;
      this.ready = true;

      this.button = this.querySelector('[data-msa-btn]');
      this.priceTarget = this.querySelector('[data-msa-price]');
      this.priceNow = this.querySelector('[data-msa-now]');
      this.priceWas = this.querySelector('[data-msa-was]');
      this.priceWasWrap = this.querySelector('[data-msa-was-wrap]');
      this.priceSaleLabel = this.querySelector('[data-msa-sale-label]');
      this.sectionId = this.getAttribute('data-section') || '';
      this.info = document.querySelector('.product-information');
      this.form = document.querySelector('.product-information product-form') || this.info;

      if (!this.button || !this.form) return;

      this.sync = this.sync.bind(this);
      this.request = this.request.bind(this);

      this.button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          var source = this.source();
          if (source) source.click();
        }.bind(this)
      );

      window.addEventListener('scroll', this.request, { passive: true });
      window.addEventListener('resize', this.request, { passive: true });
      window.addEventListener('pageshow', this.sync);

      // Printess-Button und Cookie-Banner kommen erst nachträglich dazu.
      this.mutation = new MutationObserver(this.request);
      this.mutation.observe(this.form, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled', 'style', 'class'],
        characterData: true,
      });
      // Beim Variantenwechsel tauscht Habitat den Inhalt von #price-<section> aus und
      // setzt bei einer nicht vorhandenen Kombination visibility-hidden an diesen Rahmen
      // (product.js). Beobachtet wird deshalb der dauerhafte Rahmen, nicht der Preisknoten.
      var wrap = this.priceWrap();
      if (wrap) {
        this.mutation.observe(wrap, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      } else if (this.info && this.info !== this.form) {
        this.mutation.observe(this.info, { subtree: true, childList: true, characterData: true });
      }
      this.mutation.observe(document.body, { childList: true });

      var ticks = 0;
      this.timer = setInterval(
        function () {
          ticks += 1;
          this.sync();
          if (ticks >= 20) clearInterval(this.timer);
        }.bind(this),
        400
      );

      this.sync();
    }

    disconnectedCallback() {
      if (this.moved && this.parentElement === document.body) return;
      if (this.mutation) this.mutation.disconnect();
      if (this.timer) clearInterval(this.timer);
      if (this.frame) cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.request);
      window.removeEventListener('resize', this.request);
      window.removeEventListener('pageshow', this.sync);
      document.documentElement.classList.remove('msa-open');
    }

    request() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(
        function () {
          this.frame = null;
          this.sync();
        }.bind(this)
      );
    }

    // Derselbe Rahmen, den Habitat beim Variantenwechsel neu befüllt (#price-<section>).
    priceWrap() {
      return this.sectionId ? document.getElementById('price-' + this.sectionId) : null;
    }

    findPrice() {
      // Kennt die Leiste ihre Section, zählt nur deren Preisrahmen. So landet nie der
      // Preis einer Produktkarte (Ergänzungsprodukte, Schnellansicht) in der Leiste.
      if (this.sectionId) {
        var wrap = this.priceWrap();
        return wrap ? wrap.querySelector('.price') : null;
      }
      // Älterer Seitenstand ohne data-section: erster Preis im Kaufbereich.
      var prices = document.querySelectorAll('.product-information .price');
      for (var i = 0; i < prices.length; i++) {
        if (!prices[i].closest(EXCLUDE)) return prices[i];
      }
      return null;
    }

    // Der Preisblock der Produktseite. Nach einem Variantenwechsel hängt der gemerkte
    // Knoten nicht mehr im Dokument und wird neu gesucht.
    price() {
      if (!this.priceSource || !this.priceSource.isConnected) this.priceSource = this.findPrice();
      return this.priceSource;
    }

    // Der echte, sichtbare Kaufbutton der Produktseite (nie der in einer Leiste).
    source() {
      var candidates = document.querySelectorAll('#AddToCart, .printess-integration-button');
      for (var i = 0; i < candidates.length; i++) {
        var element = candidates[i];
        if (!element.closest(EXCLUDE) && isVisible(element)) return element;
      }
      return null;
    }

    bannerOpen() {
      var banner = document.getElementById('shopify-pc__banner');
      if (!banner) return false;
      var style = getComputedStyle(banner);
      return style.display !== 'none' && style.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
    }

    renderPrice(node) {
      // Gibt es die gewählte Kombination nicht, blendet Habitat den Preis aus
      // (visibility-hidden); im Block steht dann nur ein Platzhalterpreis.
      var unavailable = !!node.closest('.visibility-hidden');
      this.priceTarget.hidden = unavailable;
      if (unavailable) return;

      var price = readPrice(node);
      if (!price) return;

      // Leiste aus einem älteren Seitenstand ohne eigene Preis-Elemente: nur aktueller Preis.
      if (!this.priceNow) {
        this.priceTarget.textContent = price.now;
        return;
      }

      var key = price.was + '|' + price.now;
      if (key === this.priceKey) return;
      this.priceKey = key;

      var sale = price.was !== '';
      this.priceNow.textContent = price.now;
      if (this.priceWas) this.priceWas.textContent = sale ? price.was : '';
      if (this.priceWasWrap) this.priceWasWrap.hidden = !sale;
      if (this.priceSaleLabel) this.priceSaleLabel.hidden = !sale;
    }

    sync() {
      var source = this.source();

      if (source) {
        var labelNode = source.querySelector('span:not(.loading-overlay)');
        var label = ((labelNode ? labelNode.textContent : source.textContent) || '').replace(/\s+/g, ' ').trim();
        // In der schmalen Leiste reicht die Kurzform, damit Preis und Titel lesbar bleiben.
        label = label.replace(/^In den Warenkorb legen$/i, 'In den Warenkorb');
        if (label) this.button.textContent = label;
        this.button.disabled = !!source.disabled;
      }

      var priceNode = this.price();
      if (priceNode && this.priceTarget) this.renderPrice(priceNode);

      this.toggle(source);
    }

    toggle(source) {
      var show = false;
      // Auf großen Bildschirmen ist die Leiste per CSS aus; dann nichts umschalten.
      var active = getComputedStyle(this).display !== 'none';
      if (active && source && !this.bannerOpen()) {
        var rect = source.getBoundingClientRect();
        var height = window.innerHeight || document.documentElement.clientHeight;
        var buttonInView = rect.bottom > 0 && rect.top < height;
        show = !buttonInView;
      }

      this.setAttribute('data-visible', show ? 'true' : 'false');
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      // Versteckt nicht per Tastatur erreichbar (Barrierefreiheit).
      if (show) this.removeAttribute('inert');
      else this.setAttribute('inert', '');
      document.documentElement.classList.toggle('msa-open', show);
    }
  }

  customElements.define('mobile-sticky-atc', MobileStickyAtc);
})();
